import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import NoDataFound from "./NoDataFound";

const ProtectedRoute = ({ children, requiredRole }) => {
  const isAuthenticated = !!localStorage.getItem("authToken");

  const userRole = useSelector((state) => state.login);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const roleAllowed =
    userRole === null
      ? "user"
      : userRole.fld_usertype || (userRole?.fld_isadmin === 1 && "Staff");

  if (!requiredRole.includes(roleAllowed)) {
    return <Navigate to="/CustomError404" replace />;
  }

  return children;
};

export default ProtectedRoute;
